/* sp-filter-autoapply v1 — 2026-08-03
 * Diamond-search carat/price number inputs only applied on Enter/blur ('change').
 * Result: 147 rage-clicks in 4 days from shoppers typing and watching nothing happen.
 * Fix: debounced 'input' -> synthetic 'change' event, reusing the page's own apply
 * logic untouched. Additive file; removing it restores exact previous behavior.
 */
(function () {
  'use strict';
  var IDS = ['sd-carat-min-num', 'sd-carat-max-num', 'sd-price-min', 'sd-price-max'];
  var timers = {}, last = {};

  function arm() {
    IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || el.__spAuto) return;
      el.__spAuto = true;
      el.addEventListener('input', function () {
        clearTimeout(timers[id]);
        timers[id] = setTimeout(function () {
          var v = el.value;
          if (v === last[id]) return;
          if (v !== '' && isNaN(parseFloat(v))) return;
          last[id] = v;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }, 700);
      });
      // a real Enter/blur 'change' cancels our pending timer so nothing double-fires
      el.addEventListener('change', function () {
        last[id] = el.value;
        clearTimeout(timers[id]);
      });
    });
  }

  arm();
  // the search page re-renders itself after load — re-arm until inputs exist
  var n = 0;
  var iv = setInterval(function () { arm(); if (++n > 10) clearInterval(iv); }, 1000);
})();
